import { createSlice } from '@reduxjs/toolkit';

import { getPutaway, createPutawayItem, getPutawayMaterials } from "../../apis";

export const putawayPlatform = createSlice({
  name: "putaway",
  initialState: {
    loading: false,
    error: "",
    getPutawayData: [],
    getPutawayMaterialsData: [],
    createPutawayItemSuccess: false,
  },
  reducers: {
    clear: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
      setPutawayMaterialsData: (state, action) => {
        state.getPutawayMaterialsData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPutaway.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getPutaway.fulfilled, (state, action) => {
      state.loading = false;
      state.getPutawayData = action.payload.data;
    });
    builder.addCase(getPutaway.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(getPutawayMaterials.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getPutawayMaterials.fulfilled, (state, action) => {
      state.loading = false;
      state.getPutawayMaterialsData = action.payload.data;
    });
    builder.addCase(getPutawayMaterials.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });

    builder.addCase(createPutawayItem.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createPutawayItem.fulfilled, (state, action) => {
      state.loading = false;
      state.createPutawayItemSuccess = true;
    });
    builder.addCase(createPutawayItem.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
});

export const { clear, setPutawayMaterialsData } = putawayPlatform.actions;

export default putawayPlatform.reducer